[
  {
    "id": "SR-E7-BACTERIEN-V01",
    "module": "SpellingRegel",
    "difficulty": 205,
    "difficultyTier": 11,
    "levelCode": "E7",
    "group": 7,
    "skill": "schrijfwijze",
    "subSkill": "trema",
    "familyId": "SR-TREMA-IEN",
    "conceptId": "trema_ie_plural",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Kies het juiste woord: ...",
    "options": ["bacteriën", "bacterien", "bacterieen", "bacterièn"],
    "correctAnswer": 0,
    "explanation": "Bacterie + en = bacteriën. De klemtoon ligt NIET op de '-ie', dus schrijf je '-iën' met trema. Dit voorkomt dat je 'bacterie-en' als drie lettergrepen leest.",
    "distractorExplanations": {
      "1": "Trema vergeten. Zonder trema is de uitspraak onduidelijk.",
      "2": "Geen extra 'e'. Het is '-iën', niet '-ieen'.",
      "3": "Dit is een accent grave (è), geen trema (ë). Een trema heeft twee puntjes."
    }
  },
  {
    "id": "SR-E7-KNIEEN-V01",
    "module": "SpellingRegel",
    "difficulty": 205,
    "difficultyTier": 11,
    "levelCode": "E7",
    "group": 7,
    "skill": "schrijfwijze",
    "subSkill": "trema",
    "familyId": "SR-TREMA-IEEN",
    "conceptId": "trema_ie_stressed_plural",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Welk woord is goed geschreven?",
    "options": ["knieën", "knien", "knieen", "kniën"],
    "correctAnswer": 0,
    "explanation": "Knie + en = knieën. De klemtoon ligt WEL op de '-ie', dus schrijf je '-ieën' met trema. De extra 'e' is nodig voor de uitspraak.",
    "distractorExplanations": {
      "1": "Te kort. Er missen letters. Het is knie + en = knieën.",
      "2": "Trema vergeten. Zonder trema zou je 'knieen' als twee lettergrepen lezen.",
      "3": "Er mist een 'e'. Het is knie-ën, niet kni-ën."
    }
  },
  {
    "id": "SR-E7-PER-SE-V01",
    "module": "SpellingRegel",
    "difficulty": 205,
    "difficultyTier": 11,
    "levelCode": "E7",
    "group": 7,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_frans",
    "familyId": "SR-WEETWOORD-PER-SE",
    "conceptId": "latin_loanword_two_words",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Kies het juiste woord: ...",
    "options": ["per se", "persé", "persee", "perse"],
    "correctAnswer": 0,
    "explanation": "'Per se' zijn twee woorden. In de nieuwe spelling is er geen accent meer nodig. Het is een Latijnse uitdrukking die 'per definitie' of 'absoluut' betekent.",
    "distractorExplanations": {
      "1": "Het accent is niet meer nodig in de nieuwe spelling. En het zijn twee woorden.",
      "2": "Geen dubbele 'e'. Het zijn twee losse woorden: per se.",
      "3": "Het zijn twee woorden, niet één. Per se."
    }
  },
  {
    "id": "SR-E7-KANGOEROE-V01",
    "module": "SpellingRegel",
    "difficulty": 205,
    "difficultyTier": 11,
    "levelCode": "E7",
    "group": 7,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_moeilijk",
    "familyId": "SR-WEETWOORD-KANGOEROE",
    "conceptId": "tricky_vowel_endings",
    "variantIndex": 2,
    "questionType": "multiple_choice",
    "question": "Welk woord is goed geschreven?",
    "options": ["kangoeroe", "kangeroe", "kangoero", "kangroe"],
    "correctAnswer": 0,
    "explanation": "'Kangoeroe' heeft twee keer 'oe': kang-oe-r-oe. Het eindigt op '-oe', niet op '-o'.",
    "distractorExplanations": {
      "1": "Hier ontbreekt de eerste 'oe'. Het woord heeft twee keer 'oe'.",
      "2": "Het eindigt op '-oe', niet op '-o'.",
      "3": "Er missen letters. Het is kang-oe-roe."
    }
  },
  {
    "id": "SR-E7-ONMIDDELLIJK-V01",
    "module": "SpellingRegel",
    "difficulty": 205,
    "difficultyTier": 11,
    "levelCode": "E7",
    "group": 7,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_moeilijk",
    "familyId": "SR-WEETWOORD-ONMIDDELLIJK",
    "conceptId": "tricky_double_consonants",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Welk woord is goed geschreven?",
    "options": ["onmiddellijk", "onmidelijk", "onmiddelijk", "onmidellijk"],
    "correctAnswer": 0,
    "explanation": "'Onmiddellijk' heeft een dubbele 'd' én een dubbele 'l'. Onthoud: on-middel-lijk. Het woord 'middel' zit erin.",
    "distractorExplanations": {
      "1": "Hier ontbreken zowel een 'd' als een 'l'. Het woord heeft dubbel-d en dubbel-l.",
      "2": "Hier ontbreekt een 'l'. Het is on-middel-lijk met dubbele 'l'.",
      "3": "Hier ontbreekt een 'd'. Het is on-middel-lijk met dubbele 'd'."
    }
  }
]